(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('mediaLast', MediaLast)

    /** @ngInject */
    function MediaLast($stateParams, $rootScope, HelperService, MediaService, AuthenticationService, PATHS, DATA_EVENTS) {
        function MediaLastController($scope) {
            const vm = this;

            vm.getNewsImage = news => {
                return HelperService.imageResizePath('news', news.Id, news.Image, 100, 100);
            }

            vm.init = () => {
                vm.news = [];
                vm.isLoading = true;

                getNews();
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                vm.init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            function getNews() {
                HelperService.startLoading('.last-elements.news');

                vm.isLoading = true;
                let userData = AuthenticationService.getUserData();
                let parameters = {
                    ResponsibilityId: userData.Responsibility.Id,
                    Active: true,
                    Highlight: true,
                    OrderBy: 'RegistrationDate',
                    OrderDescending: true,
                    PerPage: 4,
                    Skip: 0
                };

                if ($stateParams.NewsId)
                    parameters.InformativeId = $stateParams.NewsId;

                if (vm.excludeMediaId)
                    parameters.ExcludeMediaId = vm.excludeMediaId;

                MediaService
                    .getAllByParameters(parameters, userData.Id)
                    .then(success => {
                        vm.news = success.News;
                        vm.isLoading = false;
                        HelperService.stopLoading('.last-elements.news');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.news');
                    })
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            link: link,
            controller: MediaLastController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/media-last/media-last.html`,
            scope: {
                excludeMediaId: '=',
                resumed: '='
            }
        }
    }
}());